import React from 'react';
import { CircleCheckIcon } from 'lucide-react';
import { instantItems } from '../data/content';
export function InstantAccess() {
  return <section className="w-full bg-stone-50 px-5 py-20 sm:py-28" data-id="element-119" data-mp="2582nt2k0r622">
      <div className="mx-auto max-w-2xl" data-id="element-120" data-mp="1r9uia68x2wfa">
        <h2 className="text-center text-2xl font-bold leading-tight tracking-tight text-stone-900 sm:text-3xl" data-id="element-121" data-mp="1rb5n89e3ma7z">
          <span aria-hidden="true" data-id="element-122" data-mp="1vcivsr8ksril">📲 </span>What Do You Get Instantly?
        </h2>

        <ul className="mt-10 space-y-3" data-id="element-123" data-mp="1hh6nti5et4jq">
          {instantItems.map(item => <li key={item} className="flex items-center gap-3 rounded-lg border border-stone-200 bg-white px-5 py-4 text-sm font-medium text-stone-800" data-id="element-124" data-mp="1mbkljr7jnnrk">
              <CircleCheckIcon className="h-4 w-4 shrink-0 text-orange-600" aria-hidden="true" data-id="element-125" data-mp="1ckq02p24gs76" />
              {item}
            </li>)}
        </ul>

        <p className="mt-10 text-center text-lg font-semibold text-orange-600 sm:text-xl" data-id="element-126" data-mp="13iyxvu6sj3i2">
          You cover a full year of material for 10 different levels.
        </p>
      </div>
    </section>;
}